import React, { FC, useState } from 'react';

// tslint:disable-next-line:max-line-length
import { NativeDatePicker } from '@go-client/components/UIkit/forms/NativeDatePicker/NativeDatePicker';

import { Dropdown, Input, Button, InlineIcon, DropdownItem } from '@spark-labs/avocado-ui';
import { isoDate } from '@go-shared/lib/time';
import { KafkaLoggerFilters, KafkaVoyageAction } from '@go-shared/types/kafkaLogs';
import { KAFKA_VOYAGE_ACTIONS } from '@go-shared/lib/kafkaLogs';

interface KafkaLoggerHeaderProps {
  onSearch: (searchParams: KafkaLoggerFilters) => void;
}

const DROPDOWN_ITEMS = ([{ key: undefined, element: 'ALL' }] as DropdownItem[]).concat(
  KAFKA_VOYAGE_ACTIONS.map(action => ({ key: action, element: action.split(':')[1].toUpperCase() }))
);

export const KafkaLoggerHeader: FC<KafkaLoggerHeaderProps> = ({ onSearch }) => {
  const [voyageNumber, setVoyageNumber] = useState<string | undefined>(undefined);
  const [fromDate, setFromDate] = useState<string | undefined>(undefined);
  const [toDate, setToDate] = useState<string | undefined>(undefined);
  const [action, setAction] = useState<KafkaVoyageAction | undefined>(undefined);

  return (
    <div
      className={`h-full px-2 inline-flex items-end pb-5
              user-records-header w-full overflow-x-hidden`}
    >
      <div className="flex flex-col items-center w-full">
        <span className="w-full mb-5"></span>
        <div className="inline-flex w-full ">
          <span className="mr-8 input-bar" style={{ width: 300 }}>
            <Input placeholder="Voyage Number" onChange={e => setVoyageNumber(e.target.value)} />
          </span>
          <span className="mr-8">
            <NativeDatePicker
              isClearable={true}
              label="From"
              onDateChange={date => setFromDate(date ? isoDate(date) : undefined)}
            />
          </span>
          <span className="mr-8">
            <NativeDatePicker
              isClearable={true}
              label="To"
              onDateChange={date => setToDate(date ? isoDate(date) : undefined)}
            />
          </span>
          <span className="mr-8">
            <Dropdown
              selectedValue={action}
              onSelect={item => setAction(item.key as KafkaVoyageAction | undefined)}
              items={DROPDOWN_ITEMS}
            >
              {dropdownProps => (
                <a
                  href="javascript:;"
                  className="block"
                  ref={dropdownProps.toggleRef}
                  onFocus={dropdownProps.onFocus}
                  onBlur={dropdownProps.onBlur}
                  onKeyDown={dropdownProps.onKeyDown}
                >
                  <span className="inline-flex items-center">
                    <span className="text-small text-grey-darkest">Actions</span>
                    <InlineIcon
                      name="chevron-down"
                      className="dropdown-icon ml-2 text-grey-darkest"
                    />
                  </span>
                </a>
              )}
            </Dropdown>
          </span>
          <Button
            className="bg-blue-dark py-1 text-white px-4"
            onClick={() => onSearch({ voyageNumber, fromDate, toDate, action })}
          >
            Search
          </Button>
        </div>
      </div>
    </div>
  );
};
